module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"events":"Events","questions":"Questions","testing":"Testing"}}')
  delete Component.options._Ctor
}
